import { StateCreator } from 'zustand'
import type { FFEStore } from '../types'
import type { Group } from '../../types/ffe'

export interface GroupsSlice {
  addGroup: (name: string, groupId?: string) => void
  updateGroup: (id: string, updates: Partial<Group>) => void
  removeGroup: (id: string) => void
  reorderGroups: (groups: Group[]) => void
  collapseAllGroups: () => void
  expandAllGroups: () => void
}

const getAllChildGroupIds = (
  groups: Array<Group>,
  groupId: string
): Array<string> => {
  const children = groups.filter((g) => g.groupId === groupId)
  if (children.length === 0) return []
  return children.flatMap((g) => [g.id, ...getAllChildGroupIds(groups, g.id)])
}

export const createGroupsSlice: StateCreator<FFEStore, [], [], GroupsSlice> = (
  set
) => ({
  addGroup: (name, parentGroupId) =>
    set((state) => {
      const id = crypto.randomUUID()
      setTimeout(() => {
        document.getElementById(`groupTitle-${id}`)?.click()
      }, 5)
      return {
        document: {
          ...state.document,
          groups: [
            ...state.document.groups,
            { id, name, groupId: parentGroupId }
          ]
        }
      }
    }),

  updateGroup: (id, updates) =>
    set((state) => ({
      document: {
        ...state.document,
        groups: state.document.groups.map((group) =>
          group.id === id ? { ...group, ...updates } : group
        )
      }
    })),

  collapseAllGroups: () =>
    set((state) => ({
      document: {
        ...state.document,
        groups: state.document.groups.map((group) => ({
          ...group,
          isCollapsed: true
        }))
      }
    })),
  expandAllGroups: () =>
    set((state) => ({
      document: {
        ...state.document,
        groups: state.document.groups.map((group) => ({
          ...group,
          isCollapsed: false
        }))
      }
    })),

  removeGroup: (id) =>
    set((state) => {
      const deletableGroups = [
        id,
        ...getAllChildGroupIds(state.document.groups, id)
      ]

      let newLineItems = state.document.lineItems

      for (const group of deletableGroups) {
        newLineItems = newLineItems.filter((item) => item.groupId !== group)
      }

      const newGroups = state.document.groups.filter(
        (group) => !deletableGroups.includes(group.id)
      )

      return {
        document: {
          ...state.document,
          groups: newGroups,
          lineItems: newLineItems
        }
      }
    }),

  reorderGroups: (groups) =>
    set((state) => ({
      document: {
        ...state.document,
        groups
      }
    }))
})
